import { useState, useCallback } from 'react';

export interface PaginationState {
  current: number;
  pageSize: number;
  total: number;
}

export function useOrderPagination(
  searchParams: URLSearchParams,
  setSearchParams: (params: URLSearchParams, options?: { replace?: boolean }) => void,
) {
  const [pagination, setPagination] = useState<PaginationState>({
    current: parseInt(searchParams.get('page') || '1', 10),
    pageSize: parseInt(searchParams.get('pageSize') || '10', 10),
    total: 0,
  });

  const updateUrlParams = useCallback((newPagination: { current: number; pageSize: number; total?: number }) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('page', newPagination.current.toString());
    newSearchParams.set('pageSize', newPagination.pageSize.toString());
    setSearchParams(newSearchParams, { replace: true });
  }, [searchParams, setSearchParams]);

  return { pagination, setPagination, updateUrlParams } as const;
}

